import React, { useEffect, useState } from "react";
import ModalComponent from "../../../components/modals/ModalComponent";
import LoadableButton from "../../../components/button/LoadableButton";
import { Spin } from "antd";
import {
  CreateAutoFillFileApi,
  GetFileListApi,
} from "../../../api/request/service";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const CopyFileModal = ({
  isOpen,
  setIsOpen,
  data,
  createFileHandler,
  isCreateLoading,
}) => {
  const navigate = useNavigate();
  const [fileList, setFileList] = useState([]);
  const [isCopyFile, setIsCopyFile] = useState(false);
  const [isFileLoading, setIsFileLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileType = async () => {
    if (fileList?.length > 0) return;
    setIsFileLoading(true);
    try {
      const { data: fileData } = await GetFileListApi({
        service_type_id: data?.id,
      });
      setFileList(fileData?.data);
    } catch (error) {
      console.error("Failed to fetch file list:", error);
    } finally {
      setIsFileLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!selectedFile) return;
    setIsSubmitting(true);
    try {
      const { data: copyFile } = await CreateAutoFillFileApi({
        service_type_id: data?.id,
        file_id: selectedFile?.id,
      });

      navigate(`/file/${copyFile?.data?.id}`);
      toast.success(copyFile?.message);
    } catch (error) {
      console.error("Submission failed:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (isCopyFile) handleFileType();
  }, [isCopyFile]);

  useEffect(() => {
    if (!isOpen) setFileList([]);
  }, [isOpen]);

  return (
    <ModalComponent
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      width={700}
      title="Create File"
      onCancel={() => {
        setIsCopyFile(false);
        setFileList([]);
      }}
    >
      {!isCopyFile ? (
        <>
          <p className="text-center text-xl text-Gray">
            Would you like to autofill the basic information from an existing
            file?
          </p>
          <div className="flex justify-center items-center md:gap-5 gap-3 mt-4 md:mt-8">
            <LoadableButton
              lable="No"
              className="!bg-[#D91819] hover:!bg-[#aa0001]"
              onClick={() => createFileHandler(data)}
              isLoading={isCreateLoading}
              disabled={isCreateLoading}
              loadingLable="Creating file..."
            />
            <LoadableButton
              lable="Yes"
              className="!bg-[#2D9B63] hover:!bg-[#096034]"
              onClick={() => setIsCopyFile(true)}
              isLoading={isFileLoading}
              disabled={isFileLoading}
            />
          </div>
        </>
      ) : (
        ""
      )}

      {isFileLoading ? (
        <Spin className="flex z-10 w-full justify-center items-center h-full" />
      ) : fileList?.length > 0 ? (
        <>
          <p className="text-center text-xl text-Gray">
            Select a file to copy data from.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-4 mt-6">
            {fileList.map((file) => (
              <div
                key={file.id}
                className={`cursor-pointer p-4 transition-all rounded-lg duration-200 ${
                  selectedFile?.id === file.id
                    ? "border-primary border-2"
                    : "border border-gray-300"
                }`}
                onClick={() => setSelectedFile(file)}
              >
                <p className="text-lg font-semibold capitalize">
                  {file?.service_name_slug || "--"}
                </p>
                <p className="text-sm text-Gray">#{file.file_number || "--"}</p>
                <p className="text-sm text-Gray">
                  {moment(file?.created_at).format("DD-MM-YYYY")}
                </p>
              </div>
            ))}
          </div>

          <div className="flex justify-center">
            <LoadableButton
              lable="Create File"
              className="text-sm py-2 px-4 mt-4 w-fit"
              onClick={handleSubmit}
              isLoading={isSubmitting}
              disabled={isSubmitting}
              loadingLable="Creating file..."
            />
          </div>
        </>
      ) : (
        ""
      )}
    </ModalComponent>
  );
};

export default CopyFileModal;
